// Analytics super simple para my.pchardware.info

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackEvent(eventName: string, data?: any) {
  if (window.gtag) {
    window.gtag('event', eventName, data);
  }
}

export default {
  event: trackEvent
};
